module.exports = __webpack_public_path__ + "static/media/phone.207ddc81.svg";